// ลิ้นชักแชท: สไลด์จากขวา แสดงห้องเดียวด้วย UI ของ Inbox Center
//
// ฝัง iframe โหมด only=thread เพื่อให้ได้ความสามารถครบ (ตอบ แท็ก ส่งต่อ ข้อความสำเร็จรูป)
// ถ้าสร้างหน้าแชทเองจะต้องทำซ้ำทั้งหมดและตามแก้ทุกครั้งที่ฝั่งนั้นเปลี่ยน
import { useEffect } from "react";
import { Link } from "react-router";
import { menuPath } from "@features/navigation/model/side-menus";
import { cn } from "@shared/lib/utils";

export type ChatTarget = { convId: string; pageId?: string; customerName?: string };

export function ChatDrawer({
  brandId,
  target,
  onClose,
}: {
  brandId: string;
  target: ChatTarget | null;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!target) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [target, onClose]);

  const q = new URLSearchParams({ embed: "1", only: "thread", conv: target?.convId ?? "" });
  if (target?.pageId) q.set("page", target.pageId);

  return (
    <>
      <div className={cn("chat-drawer-overlay", target && "open")} onClick={onClose} />
      <aside className={cn("chat-drawer", target && "open")}>
        <div className="chat-drawer-head">
          <div className="grow">
            <div className="chat-drawer-title">{target?.customerName || "แชท"}</div>
            <div className="muted small-note">ตอบได้จากหน้านี้เลย</div>
          </div>
          <Link
            className="btn-outline btn-sm"
            to={`${menuPath(brandId, "message")}?conv=${encodeURIComponent(target?.convId ?? "")}`}
          >
            เปิดในเมนู Messages ↗
          </Link>
          <button type="button" className="icon-btn" title="ปิด" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="chat-drawer-body">
          {/* ปิดแล้วต้องถอด iframe ทิ้ง ไม่ให้ห้องเก่าค้างอยู่เบื้องหลังและยังโหลดข้อความต่อ */}
          {target && <iframe src={`/inbox/index.html?${q}`} title="แชท" allow="clipboard-write" />}
        </div>
      </aside>
    </>
  );
}
